var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 59,
    viewBox: "0 0 49 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_912_9728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_912_9728",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 29,
    height: 39,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10,
    y: 9,
    width: 29,
    height: 39
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.88 34.4953C32.5818 33.0517 36 28.675 36 23.5C36 17.1487 30.8513 12 24.5 12C18.1487 12 13 17.1487 13 23.5C13 28.675 16.4182 33.0517 21.12 34.4953L24.5 41L27.88 34.4953Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.88 34.4953C32.5818 33.0517 36 28.675 36 23.5C36 17.1487 30.8513 12 24.5 12C18.1487 12 13 17.1487 13 23.5C13 28.675 16.4182 33.0517 21.12 34.4953L24.5 41L27.88 34.4953Z",
    fill: "#F2E7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.88 34.4953L26.9994 31.6274L25.7976 31.9964L25.2179 33.112L27.88 34.4953ZM21.12 34.4953L23.7821 33.112L23.2024 31.9964L22.0006 31.6274L21.12 34.4953ZM24.5 41L21.8379 42.3833L24.5 47.5064L27.1621 42.3833L24.5 41ZM33 23.5C33 27.3205 30.4771 30.5596 26.9994 31.6274L28.7605 37.3631C34.6864 35.5437 39 30.0295 39 23.5H33ZM24.5 15C29.1944 15 33 18.8056 33 23.5H39C39 15.4919 32.5081 9 24.5 9V15ZM16 23.5C16 18.8056 19.8056 15 24.5 15V9C16.4919 9 10 15.4919 10 23.5H16ZM22.0006 31.6274C18.5229 30.5596 16 27.3205 16 23.5H10C10 30.0295 14.3136 35.5437 20.2395 37.3631L22.0006 31.6274ZM27.1621 39.6167L23.7821 33.112L18.458 35.8785L21.8379 42.3833L27.1621 39.6167ZM25.2179 33.112L21.8379 39.6167L27.1621 42.3833L30.542 35.8785L25.2179 33.112Z",
    fill: "#985EFF",
    mask: "url(#path-1-outside-1_912_9728)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_912_9728",
    x: 0,
    y: 0,
    width: 49,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_912_9728"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_912_9728",
    result: "effect2_dropShadow_912_9728"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_912_9728",
    result: "effect3_dropShadow_912_9728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_912_9728",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.7ad20ec1045e1651d6daf26cd875e19e.svg";
export { ForwardRef as ReactComponent };